import { Routes } from '@angular/router';
import { PresenterViewComponent } from './views/presenter-view/presenter-view';
import { AssignmentsViewComponent } from './views/assignments-view/assignments-view';
import { AdminPlanViewComponent } from './views/admin-plan-view/admin-plan-view';
import { GradingViewComponent } from './views/grading-view/grading-view';

export const stepContentRoutes: Routes = [
  {
    path: '',
    redirectTo: 'presenter',
    pathMatch: 'full',
  },
  {
    path: 'presenter',
    component: PresenterViewComponent,
  },
  {
    path: 'assignments',
    component: AssignmentsViewComponent,
  },
  {
    path: 'grading',
    component: GradingViewComponent,
  },
  {
    path: 'admin-plan',
    component: AdminPlanViewComponent,
  },
];
